<template>
  <div>
    <data-select
      :size="size"
      :title="title"
      :defaultParams="defaultParams"
      :placeholder="placeholder"
      :fieldList="fieldList"
      :paramList="paramList"
      :width="1000"
      :showMenu="false"
      :menuWidth="200"
      listApi="biz.goods.supplier.info.list"
      valuePropName="guid"
    >
      <template slot="row-info" slot-scope="scope">
        <goods-sku-info :skuInfo="scope.row" :showCostPrice="false">
          <template slot="info-append" slot-scope="scope">
            <slot
              name="info-append"
              :info="scope.info.skuInfo"
              :purchasePrice="scope.info.purchasePrice"
            />
          </template>
        </goods-sku-info>
      </template>
    </data-select>
  </div>
</template>

<script>
import dataSelect from "../dataSelect.vue";
import goodsSkuInfo from "./goodsSkuInfo.vue";

export default {
  components: {
    dataSelect,
    goodsSkuInfo,
  },
  props: {
    size: {
      type: String,
    },
    title: {
      type: String,
      default: "请选择",
    },
    supplierGuid: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "选择商品",
    },
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    defaultParams() {
      return Object.assign(
        {
          optStatus: 1,
          supplierGuid: this.supplierGuid,
        },
        this.params || {}
      );
    },
  },
  data() {
    return {
      fieldList: [
        {
          label: "商品信息",
          minWidth: "320",
          slot: "info",
        },
      ],
      paramList: [],
    };
  },
};
</script>
